import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStrings } from '../../contexts/StringsContext';
import styles from './WarningModal.css';
import * as timeoutModalTypes from '../../constants/timeoutModalTypes';

export const WarningModal = ({ type, onClick, startTimeInSeconds = 0 }) => {
    const strings = useStrings();
    const buttonRef = useRef(null);
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        buttonRef?.current?.focus();

        document.body.addEventListener('focus', handleFocus, true);

        // Cleanup
        return () => {
            document.body.removeEventListener('focus', handleFocus, true);
        };
    }, [type]);

    useEffect(() => {
        if (startTimeInSeconds > 0) {
            setTimeLeft(startTimeInSeconds);

            // Interval to update the time left
            const intervalId = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);

            // Cleanup
            return () => {
                clearInterval(intervalId);
            };
        }
    }, [startTimeInSeconds]);

    function handleFocus(e) {
        if (e.target !== buttonRef.current) {
            buttonRef.current.focus();
        }
    }

    // Format time left as MM:SS
    function formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

        return formattedTime;
    }

    return (
        <div className={styles.modal}>
            <div className={styles.dialog}>
                <div className={styles.content}>
                    <div className={styles.modalBody}>
                        {type === timeoutModalTypes.WARNING &&
                            <>
                                <h1 className={styles.heading}>{strings.warningHeader}</h1>
                                <div className={styles.body}>{strings.warningBody}</div>
                                <div className={styles.countdown}>{formatTime(timeLeft)}</div>
                                <div className={styles.btn}>
                                    <button
                                        className={styles.button}
                                        onClick={onClick}
                                        ref={buttonRef}
                                    >
                                        {strings.warningButton}
                                    </button>
                                </div>
                            </>
                        }
                        {type === timeoutModalTypes.SESSION &&
                            <>
                                <h1 className={styles.heading}>{strings.sessionHeader}</h1>
                                <div className={styles.body}>{strings.sessionBody}</div>
                                <div className={styles.btn}>
                                    <button
                                        className={styles.button}
                                        onClick={onClick}
                                        ref={buttonRef}
                                    >
                                        {strings.sessionButton}
                                    </button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

WarningModal.propTypes = {
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    startTimeInSeconds: PropTypes.number
};

export default WarningModal;